<div
  class="nav-option toggle-expand"
  (click)="toggleNav()"
  [ngClass]="{ closed: !(sideNav$ | async).expanded }"
>
  @if ((sideNav$ | async).expanded) {
    <ng-icon
      name="HeroChevronRight"
      class="chevron-icon expanded"
      aria-label="Collapse navigation"
    ></ng-icon>
  }
  @if (!(sideNav$ | async).expanded) {
    <ng-icon
      name="HeroChevronRight"
      class="chevron-icon collapsed"
      aria-label="Expand navigation"
    ></ng-icon>
  }
</div>
